<template>
  <div>
    <div class="container"><privacy-terms></privacy-terms></div>
  </div>
</template>

<script>
  import privacyTerms from '../../components/privacyTerms/PrivacyTerms.vue'

  export default {
    name: 'privacy-terms-page',
    components: {
      privacyTerms
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .container {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// PrivacyTerms.vue?59efcfb4